import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
const sectionVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.25, 0.46, 0.45, 0.94],
      staggerChildren: 0.12
    }
  }
};
const childVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function CTASection() {
  return <section id="cta" className="w-full px-5 py-20 md:py-28" style={{
    backgroundColor: 'var(--color-slate)'
  }} data-id="element-1">
      <motion.div className="max-w-[720px] mx-auto text-center" initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={sectionVariants} data-id="element-2">
        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-6" style={{
        color: 'var(--color-cream)',
        opacity: 0.8
      }} data-id="element-3">
          Si llevas meses diciéndote "mañana"…
        </motion.p>

        <motion.p variants={childVariants} className="text-lg md:text-xl leading-relaxed mb-8" style={{
        color: 'var(--color-cream)',
        opacity: 0.8
      }} data-id="element-4">
          Hazlo versión mamá:
        </motion.p>

        <motion.h2 variants={childVariants} className="text-3xl md:text-4xl lg:text-5xl mb-4" style={{
        color: 'var(--color-tan)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-5">
          10 minutos. 21 días.
        </motion.h2>

        <motion.p variants={childVariants} className="text-xl md:text-2xl mb-10" style={{
        color: 'var(--color-cream)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-6">
          Un sistema que no se rompe.
        </motion.p>

        {/* Product image small */}
        <motion.div variants={childVariants} className="mb-10 flex justify-center" data-id="element-7">
          <img src="https://cdn.magicpatterns.com/uploads/jwmn9Q2ZfFsHSEvz4H2CyF/heylloyd-image-1770692828619.png" alt="Mamá 10-Minutos: Cuerpo Firme Sin Gym" className="w-48 md:w-56 h-auto rounded-xl shadow-lg" data-id="element-8" />
        </motion.div>

        {/* Price */}
        <motion.div variants={childVariants} className="mb-8" data-id="element-9">
          <p className="text-sm font-semibold uppercase tracking-widest mb-3" style={{
          color: 'var(--color-sage)'
        }} data-id="element-10">
            Oferta especial
          </p>
          <div className="flex items-center justify-center gap-4 mb-2" data-id="element-11">
            <p className="text-2xl md:text-3xl line-through" style={{
            color: 'var(--color-cream)',
            opacity: 0.35,
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-12">
              $29
            </p>
            <p className="text-5xl md:text-6xl font-bold" style={{
            color: 'var(--color-tan)',
            fontFamily: "'DM Serif Display', serif"
          }} data-id="element-13">
              $6.39
            </p>
          </div>
          <p className="inline-block text-sm font-semibold px-4 py-1.5 rounded-full mt-2 mb-1" style={{
          backgroundColor: 'rgba(168, 181, 160, 0.2)',
          color: 'var(--color-sage)'
        }} data-id="element-14">
            Ahorra 78%
          </p>
          <p className="text-base mt-3" style={{
          color: 'var(--color-cream)',
          opacity: 0.6
        }} data-id="element-15">
            PDF + calendarios + biblioteca de rutinas + trackers
          </p>
        </motion.div>

        {/* CTA Button */}
        <motion.button variants={childVariants} onClick={() => {
        window.open('https://resetconcalma.com/cart/45257475686537:1', '_blank');
      }} className="inline-flex items-center gap-3 px-10 py-5 rounded-full text-lg md:text-xl font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#C4A88240] hover:scale-[1.03] cursor-pointer" style={{
        backgroundColor: 'var(--color-tan)',
        color: 'var(--color-slate)'
      }} data-id="element-16">
          Descárgalo ahora — Solo $6.39
          <ChevronRightIcon className="w-5 h-5" data-id="element-17" />
        </motion.button>

        <motion.p variants={childVariants} className="text-sm mt-6" style={{
        color: 'var(--color-cream)',
        opacity: 0.4
      }} data-id="element-18">
          Descarga inmediata · PDF compatible con cualquier dispositivo
        </motion.p>
      </motion.div>
    </section>;
}